<section class="spacer-pt-space spacer-pb-space overflow-hidden">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="intro-text lg:hidden !mb-5">
                    <h2 class="heading-primary-8xl" [innerHTML]="data.heading"></h2>
                    <div class="editor-content" [innerHTML]="data.description"></div>
                </div>
                <ul class="tabsContentWrapper">
                    @for(item of data.items; track $index){
                    <li [class.active]="activeTabIndex === $index">
                        <img [ngSrc]="assetsCDNUrl+item.mapImage" alt="{{item.title}}" width="660" height="535"
                            class="tabsContentWrapper__img" loading="lazy" />
                        <div class="tabsContentWrapper__card">
                            <img [ngSrc]="assetsCDNUrl+item.cardIcon" class="tabsContentWrapper__cardIcon"
                                class="mb-[11px]" alt="{{item.title}}" width="63" height="63" loading="lazy" />
                            <h3 class="text-16 lg:text-20 xxl:text-22 text-black font-inter-medium mb-2">{{item.title}}
                            </h3>
                            @if (item.description) {
                            <div class="editor-content flex-1 flex flex-col justify-between"
                                [innerHTML]="item.description"></div>
                            } @else {
                            <div class="tabsContentWrapper__cardImg">
                                <img [ngSrc]="assetsCDNUrl+'/assets/images/map/location.svg'" alt="Location" width="223"
                                    height="295" loading="lazy" />
                            </div>
                            <p class="tabsContentWrapper__cardContent">coming shortly</p>
                            }
                        </div>
                    </li>
                    }
                </ul>
            </div>
            <div class="col-lg-6">
                <div class="intro-text hidden lg:block">
                    <h2 class="heading-primary-8xl" [innerHTML]="data.heading"></h2>
                    <div class="editor-content" [innerHTML]="data.description"></div>
                </div>
                <div class="swiper !overflow-visible mb-8 lg:mb-0" id="map-slider">
                    <ul class="tabsWrapper swiper-wrapper">
                        @for(item of data.items; track $index){
                        <li class="swiper-slide" [class.active]="activeTabIndex === $index" (click)="selectTab($index)">
                            <img [ngSrc]="assetsCDNUrl+item.tabIcon" class="mb-[11px]" alt="{{item.title}}" width="63"
                                height="63" loading="lazy" />
                            <p class="text-14 xxl:text-18 text-[#2D2D2D] font-inter-regular mb-0">{{item.title}}</p>
                        </li>
                        }
                    </ul>
                    <div class="swiper-pagination swiper-map-pagination !-bottom-8 md:!-bottom-12"></div>
                </div>
            </div>
        </div>
    </div>
</section>